<ngx-gov-co-shd-app-header-auth>
  <div *ngIf="showViewHTMLComponent" shd-container-router-component>
    <div class="container-shd-component-menu-panel-right">
      <div class="row-shd-component-menu-panel-right">
        <div class="col-main-shd-component-menu-panel-right">
          <nav aria-label="breadcrumb-shd-component-menu-panel-right">
            <ol class="breadcrumb-shd-component-menu-panel-right">
              <li class="breadcrumb-item-shd-component-menu-panel-right">
                <a href="javascript:void(0)">Mis impuestos</a>
              </li>
              <li class="breadcrumb-item-shd-component-menu-panel-right">
                <a href="javascript:void(0)">Retención ICA</a>
              </li>
              <li class="breadcrumb-item-shd-component-menu-panel-right">
                <a href="javascript:void(0)" class="active">Firmar</a>
              </li>
            </ol>
          </nav>
          <div class="banner-step-info-container">
            <div class="banner-step-info-content">
              <div class="step-circle">2</div>
              <span class="banner-step-info-texto">Firmar</span>
            </div>
            <div class="banner-step-info-imagen-container">
              <img [src]="urlsPaso.dos" alt="Firmar" class="banner-step-info-imagen">
            </div>
          </div>
          <div class="container-tabs-items">
            <div class="tab-item" [class.active]="tabs[0]" (click)="changeTab(1)" (keydown.enter)="changeTab(1)"   tabindex="0" aria-label="Firma Electrónica">
              <span>Firma Electrónica</span>
            </div>
          </div>
          <div>
            <app-firmar-electronicamente-pendientes-reteica *ngIf="tabs[0]"></app-firmar-electronicamente-pendientes-reteica>
          </div>
        </div>
      </div>
    </div>
  </div>
</ngx-gov-co-shd-app-header-auth>